import type { ChatRoom } from 'models';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, EntitySnippet, Flex, Icon } from 'ui';
import { useGroupChatRoomInfo } from '../hooks';
import { ChatGroupInfoModal } from './chat-group-info-modal';

type P = {
  chatroom: ChatRoom;
  onChatDeleted: () => Promise<void>;
};

const ChatGroupHeader = ({ chatroom, onChatDeleted }: P) => {
  const { t } = useTranslation();
  const { membersCount, name } = useGroupChatRoomInfo(chatroom);
  const [isInfoModalOpened, setIsInfoModalOpened] = useState(false);

  return (
    <>
      <Flex align="center" className="chat-header" justify="space-between">
        <EntitySnippet
          avatarProps={{
            icon: <Icon color="text" icon="group-line" />,
            size: 'lg',
          }}
          descriptionProps={{ children: t('membersCount', { count: membersCount }) }}
          titleProps={{
            children: name,
            ellipsis: { tooltip: name },
            weight: 'medium',
          }}
        />
        <Button
          icon={<Icon icon="information-line" />}
          onClick={() => {
            setIsInfoModalOpened(true);
          }}
          type="text"
        />
      </Flex>
      <ChatGroupInfoModal
        chatroom={chatroom}
        isOpened={isInfoModalOpened}
        onChatDeleted={onChatDeleted}
        onClose={() => {
          setIsInfoModalOpened(false);
        }}
      />
    </>
  );
};

export default ChatGroupHeader;
